import React from 'react';
import Navigation from '../tulote/Navigation';
import ConvertirGeoJSON from '../tulote/ConvertirGeoJSON';
import Footer from '../tulote/Footer';
import ThemeTogglerTwo from '../tulote/ThemeTogglerTwo';
import { ThemeProvider } from '../ThemeProvider';

function ConvertirGeoJSONPage() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
        <Navigation />
        <section id="convertir-geojson">
          <ConvertirGeoJSON />
        </section>
        <Footer />
        <div className="fixed bottom-6 right-6 z-50 hidden sm:block">
          <ThemeTogglerTwo />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default ConvertirGeoJSONPage;
